<template>
  <div class="filter-widget">
    <h2 class="widget-title" :class="{active: active}" @click="active=!active"><span></span>{{$t("shop.sidebar."+filter.label)}}</h2>
    <div class="widget-listing-box" v-show="['md', 'lg', 'xl', 'hd', 'inf'].includes($mq) || active">
      <div class="widget-listing">
        <ul class="size">
          <li v-for="(option, option_key) in filter.options" :key="option_key">
            <input
              type="checkbox"
              @change="set_query(option)"
              v-model="option.selected"
              :id="'check'+option.id"
            />
            <label
              :for="'check'+option.id"
              :style="{backgroundColor: option.key, border: '1px solid ' + option.key}"
            >{{option.key}}</label>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['filter'],
  data () {
    return {
      selected_options: [],
      active: false
    }
  },
  methods: {
    set_query (option) {
      this.$emit('set_query', option, this.filter.name)
    }
  }
}
</script>
